import { useMutation } from "@tanstack/react-query";
import { RequestError } from "@/axios/schema.ts";
import {
	sendPhone2FA,
	SendPhone2FAPayload,
	SendPhone2FAResponse,
} from "@/api/phone-auth.ts";

export default function useSendPhone2FA() {
	return useMutation<
		SendPhone2FAResponse,
		RequestError,
		{ payload: SendPhone2FAPayload }
	>({
		mutationFn: async ({ payload }) => sendPhone2FA(payload),
	});
}
